// Copyright (C) AirWorks Solutions, Inc - All Rights Reserved
// DO NOT REDISTRIBUTE
// UNAUTHORIZED COPYING OF THIS FILE, ANY PART OR WHOLE, VIA ANY MEDIUM IS STRICTLY PROHIBITED
// PROPRIETARY AND CONFIDENTIAL

import Widget from '@arcgis/core/widgets/Widget';
import { tsx } from '@arcgis/core/widgets/support/widget';

import SceneView from '@arcgis/core/views/SceneView';
import DirectLineMeasurement3D from '@arcgis/core/widgets/DirectLineMeasurement3D';
import AreaMeasurement3D from '@arcgis/core/widgets/AreaMeasurement3D';

import '@esri/calcite-components/dist/calcite/calcite.css';

type LengthUnit = 'feet' | 'us-feet' | 'meters';
type AreaUnit = 'square-feet' | 'square-us-feet' | 'square-meters';

interface UnitToggleProps {
  view: SceneView;
  distanceMeasurement: DirectLineMeasurement3D;
  areaMeasurement: AreaMeasurement3D;
  imperialLengthUnit: LengthUnit;
  imperialAreaUnit: AreaUnit;
}

class MeasurementUnitToggle extends Widget {
  view: SceneView;

  distanceMeasurement: DirectLineMeasurement3D;

  areaMeasurement: AreaMeasurement3D;

  imperialLengthUnit: LengthUnit;

  imperialAreaUnit: AreaUnit;

  isMetric = false;

  name = 'measurementUnitToggle';

  constructor(params: UnitToggleProps) {
    super(params);
    this.view = params.view;
    this.distanceMeasurement = params.distanceMeasurement;
    this.areaMeasurement = params.areaMeasurement;
    this.imperialLengthUnit = params.imperialLengthUnit;
    this.imperialAreaUnit = params.imperialAreaUnit;
    this._applyUnits();
  }

  _applyUnits() {
    this.distanceMeasurement.unit = this.isMetric ? 'meters' : this.imperialLengthUnit;
    this.areaMeasurement.unit = this.isMetric ? 'square-meters' : this.imperialAreaUnit;
  }

  _handleClick() {
    this.isMetric = !this.isMetric;
    this._applyUnits();
    this.scheduleRender();
  }

  render() {
    return tsx(
      'div',
      {
        class: 'esri-widget esri-widget--button',
        style: 'cursor:pointer;font-weight:600;display:flex;align-items:center;justify-content:center;',
        title: this.isMetric ? 'Switch measurement units to feet' : 'Switch measurement units to meters',
        onclick: this._handleClick.bind(this),
      },
      this.isMetric ? 'm' : 'ft',
    );
  }
}

export default MeasurementUnitToggle;
